import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { CustomEase } from "gsap/CustomEase.js";

gsap.registerPlugin(ScrollTrigger, CustomEase);

let bezierEase = CustomEase.create("custom", "0.5, 0, 0.2, 1");

const bottom_sections = [
  document.querySelector(".top-footer__bottom-contact"),
  ...document.querySelectorAll(".top-footer__bottom-addresses-cell"),
];

const footer_menu_items = document.querySelectorAll(
  ".bottom-footer__menu > li",
);

if (document.querySelector(".top-footer__top")) {
  gsap.set(".top-footer__title .single-line", { overflow: "hidden" });
  gsap.fromTo(
    ".top-footer__title .single-line-inner",
    { y: "100%" },
    {
      scrollTrigger: {
        start: "top bottom+=20",
        trigger: ".top-footer__top",
      },
      y: 0,
      duration: 1,
      ease: bezierEase,
    },
  );
}

if (document.querySelector(".top-footer__bottom")) {
  let bottom_timeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".top-footer__bottom",
      start: "top bottom+=20",
    },
  });

  bottom_sections.forEach((item, index) => {
    gsap.set(item, { opacity: 0, y: -45 });
    bottom_timeline.to(
      item,
      { opacity: 1, y: 0, duration: 0.5, ease: bezierEase },
      index === 0 ? "" : ">-0.25",
    );
  });
}

if (footer_menu_items.length) {
  let menu_timeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".bottom-footer__menu",
      start: "top bottom+=20",
    },
  });

  footer_menu_items.forEach((item, index) => {
    gsap.set(item, { opacity: 0, y: -45 });
    menu_timeline.to(
      item,
      { opacity: 1, y: 0, duration: 0.5, ease: bezierEase },
      index === 0 ? "" : ">-0.25",
    );
  });
}
